// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2JFwa","messages":"Chat_messages__2ZA1J","dateDivider":"Chat_dateDivider__2cFzp"};